import React from 'react';
import { Card, Typography, Alert } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';

const { Title } = Typography;

interface RNAhybridResultProps {
  data?: any;
  taskResult?: any;
}

interface RNAhybridResult {
  raw_output?: string;
  mfe?: number;
  position?: string;
  target_sequence?: string;
  mirna_sequence?: string;
  alignment?: string;
}

const RNAhybridResult: React.FC<RNAhybridResultProps> = ({ data, taskResult }) => {
  // 提取RNAhybrid结果数据
  let rnaResult: any = null;
  let parameters: any = {};
  
  // 提取参数信息
  if (taskResult?.parameters) {
    parameters = taskResult.parameters;
  } else if (data?.parameters) {
    parameters = data.parameters;
  }
  
  // 处理统一格式数据：从results[0].result中提取实际数据
  if (taskResult?.result?.results && Array.isArray(taskResult.result.results) && taskResult.result.results.length > 0) {
    rnaResult = taskResult.result.results[0].result;
  }
  // 处理从data传入的统一格式数据（检查是否有嵌套的result字段）
  else if (data?.results && Array.isArray(data.results) && data.results.length > 0) {
    // 检查是否有嵌套的result字段
    if (data.results[0].result) {
      rnaResult = data.results[0].result;
    } else {
      // 直接使用results[0]的数据
      rnaResult = data.results[0];
    }
  }
  // 处理直接数据
  else if (data?.raw_output || data?.success !== undefined) {
    rnaResult = data;
  }
  

  if (!rnaResult || !rnaResult.raw_output) {
    return (
      <Alert
        type="warning"
        message="无RNAhybrid结果数据"
        description="任务可能还在运行中或者结果格式不正确"
        showIcon
      />
    );
  }



  // 替换command_line为实际序列信息
  const enhanceOutput = (rawOutput: string) => {
    if (!rawOutput) return rawOutput;
    
    let enhanced = rawOutput;
    
    // 替换command_line为实际序列信息
    if (rnaResult.mirna_sequence && rnaResult.target_sequence) {
      enhanced = enhanced.replace(/miRNA : command_line/g, `miRNA : ${rnaResult.mirna_sequence}`);
      enhanced = enhanced.replace(/target: command_line/g, `target: ${rnaResult.target_sequence}`);
    } else if (parameters.mirna_sequence && parameters.target_sequence) {
      enhanced = enhanced.replace(/miRNA : command_line/g, `miRNA : ${parameters.mirna_sequence}`);
      enhanced = enhanced.replace(/target: command_line/g, `target: ${parameters.target_sequence}`);
    }
    
    return enhanced;
  };

  return (
    <div>
      <Title level={4}>RNAhybrid预测结果</Title>
      
      {/* 显示预测结果 */}
      <Card>
        <pre style={{ 
          backgroundColor: '#f5f5f5', 
          padding: 16, 
          borderRadius: 6, 
          fontFamily: 'monospace',
          fontSize: '13px',
          whiteSpace: 'pre-wrap',
          border: '1px solid #d9d9d9',
          lineHeight: '1.4',
          overflow: 'auto'
        }}>
          {enhanceOutput(rnaResult.raw_output)}
        </pre>
      </Card>
    </div>
  );
};

export default RNAhybridResult;
